export const BUILDING_COLORS = {
  "Army_Camp": "#F8AE80",
  "Town_Hall": "#ef4444",
  "Elixir_Collector": "#CAB1E9",
  "Elixir_Storage": "#FFD2FF",
  "Gold_Mine": "#FEEB80",
  "Gold_Storage": "#F3D697",
  "Barracks": "#B2C0CF",
  "Laboratory": "#ED97DB",
  "Cannon": "#D1C8C2",
  "Archer_Tower": "#9BC289",
  "Wall": "#d97706",
  "Wizard_Tower": "#AAA1BA",
  "Air_Defense": "#F5C08F",
  "Mortar": "#D5D6DF",
  "Clan_Castle": "#B7B9B3",
  "Builders_Hut": "#9B9B99",
  "Hidden_Tesla": "#C7DBD9",
  "Spell_Factory": "#FCF1C1",
  "XBow": "#DEB7E1",
  "Dark_Elixir_Drill": "#9B9391",
  "Dark_Elixir_Storage": "#9292A0",
  "Dark_Barracks": "#EDA5A3",
  "Inferno_Tower": "#F1A086",
  "Air_Sweeper": "#FF9590",
  "Dark_Spell_Factory": "#F0A7A7",
  "Bomb_Tower": "#B8BFD8",
  "Eagle_Artillery": "#F8E3DA", //
  "Scatter_Shot": "#A6CBDF", //
  "Spell_Tower": "#9B92AF", //
  "Monolith": "#ADA8C2", //
  "Workshop": "#D78D74",//
  "Pet_House": "#66B3A3",
  "Builder_Gold_Mine": "#FEEB80",
  "Builder_Gold_Storage": "#F3D697",
  "Builder_Elixir_Collector": "#CAB1E9",
  "Builder_Elixir_Storage": "#FFD2FF",
  "Gem_Mine": "#90E06B",
  "Builder_Barracks": "#dc7870",
  "Builder_Army_Camp": "#f6b055",
  "Star_Laboratory": "#739ad8",
  "Battle_Machine_Altar": "#dd7e6e",
  "Reinforcement_Camp": "#cf7c93",
  "Healing_Hut": "#e0c36c",
  "Battle_Copter_Altar": "#da7871",

  "Blacksmith": "#9ED7D2",
  "Hero_Hall": "#BDA09D",

  "Bomb": "#6584B4",
  "Spring_Trap": "#ddb9a1",
  "Giant_Bomb": "#CF4A4F",
  "Air_Bomb": "#ea617f",
  "Seeking_Air_Mine": "#657279",
  "Skeleton_Trap": "#C28157",
  "Tornado_Trap": "#A4748A",
  "Giga_Bomb": "#fd774f",

  "Barbarian_King": "#e16c6a",
  "Archer_Queen": "#957bd0",
  "Grand_Warden": "#cb7ad1",
  "Royal_Champion": "#698ce3",
  "Minion_Prince": "#3bb5dd"
};